import { render, staticRenderFns } from "./sound.vue?vue&type=template&id=4eaa6c66&scoped=true"
import script from "./sound.vue?vue&type=script&lang=js"
export * from "./sound.vue?vue&type=script&lang=js"
import style0 from "./sound.vue?vue&type=style&index=0&id=4eaa6c66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eaa6c66",
  null
  
)

export default component.exports